import React from "react";
import { Grid, Typography, Card, CardContent, Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import UpdateIcon from "@mui/icons-material/Update";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import DescriptionIcon from "@mui/icons-material/Description";
import { PiUniteSquareFill } from "react-icons/pi";
import { FaBuilding } from "react-icons/fa";

const DetailsGrid = ({ order ,t}) => {
  
  const details = [
    {
      label: t.CustomerName,
      value: order.Customer.CustomerName ?  order.Customer.CustomerName : "N/A", // Assuming customer data exists
      icon: <PersonIcon style={{ color: "#12538B" }} />,
    },
    {
      label: t.LastUpdated,
      value: order.LastUpdate? order.LastUpdate : order.RequestDate, 
      icon: <UpdateIcon style={{ color: "#12538B" }} />,
    },
    {
      label: t.unit,
      value:order.Equipment?.EquipmenNameLocalized ? order.Equipment?.EquipmenNameLocalized : "N/A",
      icon: <PiUniteSquareFill style={{ color: "#12538B" }} />,
    },
    {
      label: t.floor,
      value: order.Equipment ? order.Equipment.FloorNumber : "N/A", 
      icon: <HomeWorkIcon style={{ color: "#12538B" }} />,
    },
    {
      label: t.building,
      value: order.FunctionLocation.LocationNameLocalized ? order.FunctionLocation.LocationNameLocalized : "N/A", // Placeholder as no contract data in your example
      icon: <FaBuilding style={{ color: "#12538B" }} />,
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", // Automatic column layout with flexible widths
        gap: 4,
        mt: 3,
      }}
    >
      {details.map((detail, index) => (
        <Card
          key={index}
          className="card"
          variant="outlined"
          sx={{
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 4px 4px 0px #00000040",
            minHeight: 180,
            width: "100%", // Ensure the card spans full width of its container
            flexWrap: "wrap",
            margin: "auto",
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start", // Changed from "left" to "flex-start" for better alignment
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                height: 40,
                width: 40,
                display: "flex",
                alignItems: "center",
                backgroundColor: "#EEEFFF",
                borderRadius: "10px",
                justifyContent: "center",
                mb: "12px",
              }}
            >
              {detail.icon}
            </Box>
            <Typography
              sx={{
                textAlign: "left",
                fontSize: "14px",
                fontWeight: 400,
                mb: "12px",
                color: "#676767",
              }}
            >
              {detail.label}
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                textAlign: "left",
                wordWrap: "break-word",
                fontSize: "16px",
              }}
            >
              {detail.value}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default DetailsGrid;
